import React, { useState } from "react";
import { Collapse, Input, Typography, Space, Pagination } from "antd";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const VehicleActivityRatesCollapse = ({ dashboardData }) => {
  const vehicleActivityRates = dashboardData.vehicleActivityRates || [];
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(vehicleActivityRates);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  // Hàm xử lý tìm kiếm
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = vehicleActivityRates.filter(
      (item) =>
        item.bien_kiem_soat.toLowerCase().includes(value) ||
        item.loai_xe.toLowerCase().includes(value)
    );

    setFilteredData(filtered);
    setCurrentPage(1); // Reset về trang đầu tiên khi tìm kiếm
  };

  // Xử lý phân trang
  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  // Dữ liệu hiển thị theo trang
  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const renderHeader = (index, item) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr", // 3 cột đều nhau
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Text>BKS: {item.bien_kiem_soat}</Text>
      <Text>Tỷ lệ HĐ: {item.ty_le_hoat_dong}%</Text>
      <Text>CP Thuê xe: {Number(item.cp_thue_xe).toLocaleString("vi-VN")} ₫</Text>
    </div>
  );

  const renderPanelContent = (item) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: "10px",
      }}
    >
      <Text>
        <strong>Loại xe:</strong> {item.loai_xe}
      </Text>
      <Text>
        <strong>Trọng tải:</strong> {item.trong_tai.toLocaleString()} kg
      </Text>
      <Text>
        <strong>Định mức NL:</strong> {item.dinh_muc_nhien_lieu} lít
      </Text>
      <Text>
        <strong>Thời gian thuê:</strong> {new Date(item.thoi_gian_thue).toLocaleDateString("vi-VN")}
      </Text>
    </div>
  );

  return (
    <div style={{ padding: "10px" }}>
      <Title level={4} style={{ textAlign: "center", marginBottom: "20px" }}>
        Chi tiết tỷ lệ hoạt động của từng xe
      </Title>
      <Space style={{ marginBottom: 16, display: "flex", justifyContent: "center" }}>
        <Input
          placeholder="Tìm kiếm BKS hoặc loại xe"
          value={searchText}
          onChange={handleSearch}
          allowClear
          style={{ width: "100%", maxWidth: "400px" }}
        />
      </Space>
      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid #f0f0f0",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Collapse accordion={false} ghost>
          {paginatedData.map((item, index) => (
            <Panel header={renderHeader(index, item)} key={item.bien_kiem_soat}>
              {renderPanelContent(item)}
            </Panel>
          ))}
        </Collapse>
      </div>
      <Pagination
        style={{ marginTop: "10px", textAlign: "center" }}
        current={currentPage}
        pageSize={pageSize}
        total={filteredData.length}
        onChange={handlePageChange}
        showSizeChanger
        pageSizeOptions={["5", "10", "20", "50"]}
      />
    </div>
  );
};

export default VehicleActivityRatesCollapse;
